const axios = require('axios');

export function shareAction(id) {
  this.toSocial.current.refs.wrapped.setMarcId(id);
  this.toSocial.current.popup();
}

export function permanentLink(id) {
  this.permanentLink.current.refs.wrapped.setMarcId(id);
  this.permanentLink.current.popup();
}

export function exportActions(items = [], exportData = {}) {
  let marcIds = items.map((k, v) => {
    return k[0];
  });

  if (marcIds.length == 0) {
    const { t } = this.props;
    alert(t`common:message.uncheckedBook`);
  } else {
    const marcIdstr = marcIds.join(',');
    if (this.state.exportMarcId != marcIdstr) {
      this.setState({ exportMarcId: marcIdstr });
    }
    if (this.state.exportData != exportData) {
      this.setState({ exportData: exportData });
    }
    this.exportBox.current.popup();
  }
}

export function forwardActions(items = []) {
  let marcIds = items.map((k, v) => {
    return k[0];
  });
   
  if (marcIds.length == 0) {
    const { t } = this.props;
    alert(t`common:message.uncheckedBook`);
  } else {    
    let self = this;
    const marcIdstr = marcIds.join(',');
    this.setState({ exportMarcId: marcIdstr },self.forwardBox.current.popup());
  }
}

export function print(marcId) {
  axios
    .post('api/HyLibWS/graphql', {
      operationName: 'getContent',
      variables: { marc_id: marcId },
      query: 'query getContent($marc_id: String) {\n        getContent(marc_id: $marc_id)}'
    })
    .then(res => {
      var p = window.open('about:blank');
      setTimeout(() => {
        p.document.write(res.data.data.getContent);

        setTimeout(() => {
          p.print();
          p.close();
        }, 500);
      }, 500);
    })
    .catch(error => {
      //console.log(error);
    });
}

export function printActions(items) {
  let marcIds = items.map((k, v) => {
    return k[0];
  });

  if (marcIds.length == 0) {
    const { t } = this.props;
    alert(t`common:message.uncheckedBook`);
  } else {
    const marcIdstr = marcIds.join(',');
    print(marcIdstr);
  }
}

export function printAction(id, e) {
  print(id);
}

export function collectActions(items) {
  const { t } = this.props;
  if (this.props.auth !== undefined && !this.props.auth) {
    alert(t('common:login.notyet'));
    return;
  }

  let marcIds = items.map((k, v) => {
    return k[0];
  });

  if (marcIds.length == 0) {
    alert(t('common:message.uncheckedBook'));
  } else {
    const marcIdstr = marcIds.join(',');

    axios
      .post('api/HyLibWS/graphql', {
        operationName: 'saveCollections',
        variables: { input: { id: marcIdstr, isPub: 1 } },
        query:
          'mutation saveCollections($input: PacMyCollectionForm) {\n        saveCollections(Input: $input) {\n        success\n        message\n      }\n      }'
      })
      .then(res => {
        if (res.data.data.saveCollections.success) {
          this.Query.current.getQueryResult().refetch();
          alert(t`common:wepac.app.addToMyCollection.success`);
        } else {
          alert(res.data.data.saveCollections.message);
        }
      })
      .catch(error => {
        //console.log(error);
      });
  }
}

export default {
  exportActions,
  shareAction,
  permanentLink,
  printActions,
  printAction,
  collectActions,
  forwardActions
};
